export class ChangePassword
{

    OldPassword:string;
    NewPassword:string;
    Mobile:string;
    ConfirmPassword:string;

}